import { render, staticRenderFns } from "./BusGisWechatDeveloperAccountsModal.vue?vue&type=template&id=2fcaa386&"
import script from "./BusGisWechatDeveloperAccountsModal.vue?vue&type=script&lang=js&"
export * from "./BusGisWechatDeveloperAccountsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports